import { Box } from '@mui/material';
import {
  DataTableExpandableRows,
  ExpandableDataTableRow,
} from '../../../common/table/DataTableExpandableRows';
import { DataTableBaseColumn, DataTableVariant } from '../../../common/table/TableTypes';
import { DataTableId } from '../../../common/table/utils';
import { EmptyState } from './EmptyState';

interface PromptsTableProps {
  rows: ExpandableDataTableRow[];
  columns: DataTableBaseColumn[];
  expandedRowId?: string;
  setExpandedRowId: (id?: string) => void;
  emptyStateTitle: string;
  emptyStateDescription: string;
}

export const PromptsTable = ({
  rows,
  columns,
  expandedRowId,
  setExpandedRowId,
  emptyStateTitle,
  emptyStateDescription,
}: PromptsTableProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: 'auto',
        padding: 3,
        paddingTop: 0,
      }}
    >
      {rows.length === 0 ? (
        <EmptyState title={emptyStateTitle} description={emptyStateDescription} />
      ) : (
        <DataTableExpandableRows
          tableId={'' as DataTableId}
          rows={rows}
          columns={columns}
          variant={DataTableVariant.medium}
          expandedRowId={expandedRowId}
          stickyHeader
          setExpandedRowId={setExpandedRowId}
          isVirtualScroll
          hideChevronButton
        />
      )}
    </Box>
  );
};
